import { createTheme } from '@mui/material/styles';
import config from './config';
import { fonts, unicodeRange } from './fontConfig';

export const myColors = config.colors;

// A custom theme for this app
const theme = createTheme({
  cssVariables: true,
  palette: {
    primary: {
      main: myColors.primary,
      contrastText: myColors.primary,
    },
    secondary: {
      main: myColors.secondary,
      light: myColors.secondaryBackground,
      contrastText: myColors.secondaryContrastText,
    },
    text: {
      primary: myColors.primary,
    },
    background: {
      default: myColors.background,
    },
  },
  typography: {
    // Use FUTURAM as the main app font
    fontFamily: `${fonts.primary.name}, ${fonts.primary.fallback}`,
    fontSize: 14,
    // Make text light by default
    fontWeightRegular: 500,
    fontWeightMedium: 500,
    fontWeightBold: 500,
    fontWeightLight: 500,
  },
  components: {
    MuiIconButton: {
      styleOverrides: {
        root: () => ({
          opacity: 0.3,
          '&:hover': {
            opacity: 1,
          },
        }),
      },
    },
    MuiButton: {
      styleOverrides: {
        root: () => ({
          // keep buttons transparent like before
          backgroundColor: 'transparent',
          opacity: 0.7,
          '&:hover': {
            opacity: 1,
          },
          fontWeight: 500,
          fontFamily: `${fonts.primary.name}, ${fonts.primary.fallback}`,
        }),
      },
    },
    // Register local fonts via CSS baseline
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: '${fonts.primary.name}';
          font-style: normal;
          font-display: swap;
          font-weight: 500;
          src: local('${fonts.primary.name}'), url(${fonts.primary.file}) format('truetype');
          unicode-range: ${unicodeRange};
        }
        @font-face {
          font-family: '${fonts.decorative.name}';
          font-style: normal;
          font-display: swap;
          font-weight: 500;
          src: local('Hello Paris Sans Regular'), local('${fonts.decorative.name}'), url(${fonts.decorative.file}) format('truetype');
          unicode-range: ${unicodeRange};
        }
        /* Ensure default text renders with primary font */
        html, body, #root {
          font-family: ${fonts.primary.name}, ${fonts.primary.fallback};
          font-weight: 500;
        }
      `,
    },
    // Make all Typography light-weight by default (can be overridden per-component)
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: `${fonts.primary.name}, ${fonts.primary.fallback}`,
          fontWeight: 400,
          // Ensure bold markdown elements render properly
          '& strong, & b': {
            fontWeight: 700,
          },
        },
      },
    },
  },
});

export default theme;